/**
 * 将后台返回的相对上传路径转为可访问 URL。
 * 开发走 vue 代理时 base 为空，直接用 /uploads/...；生产用 VUE_APP_DOMAIN。
 */
export function absMediaUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url) || /^data:/i.test(url)) return url;
  const base = (
    process.env.VUE_APP_DEV_DOMAIN ||
    process.env.VUE_APP_DOMAIN ||
    ""
  ).replace(/\/$/, "");
  const path = url.startsWith("/") ? url : `/${url}`;
  return base ? `${base}${path}` : path;
}

/** 仅会员档案头像 */
export function profileAvatarUrl(raw) {
  if (!raw) return "";
  return absMediaUrl(raw.avatarUrl || raw.AvatarUrl || "");
}

/**
 * 展示用头像：只用会员档案头像（封面 cover 不是头像）
 */
export function memberAvatarUrl(raw) {
  return profileAvatarUrl(raw);
}

export function memberNameInitial(raw) {
  const n =
    (raw &&
      (raw.name || raw.Name || raw.author || raw.Author)) ||
    "?";
  const s = String(n).trim();
  return s ? s.slice(0, 1) : "?";
}

/** 头像背景 style：有图用背景图，无图返回 {}，由模板显姓 */
export function memberAvatarStyle(raw, opts = {}) {
  const url = opts.profileOnly
    ? profileAvatarUrl(raw)
    : memberAvatarUrl(raw);
  return url ? { backgroundImage: `url(${url})` } : {};
}

/** 将台账/列表项规范为半屏详情可用结构 */
export function toDetailItem(raw) {
  if (!raw) return null;
  if (typeof raw === "string") {
    return {
      title: raw,
      content: "",
      coverUrl: "",
      meta: "",
      category: "",
      time: "",
      author: "",
      status: ""
    };
  }
  const title =
    raw.title !== undefined && raw.title !== null
      ? raw.title
      : raw.name || raw.Name || "详情";
  // 显式传了 coverUrl（含空串）时不要用 avatar 顶替，避免心得详情把人头像当封面
  const hasCoverKey =
    Object.prototype.hasOwnProperty.call(raw, "coverUrl") ||
    Object.prototype.hasOwnProperty.call(raw, "CoverUrl");
  const coverUrl = hasCoverKey
    ? raw.coverUrl || raw.CoverUrl || ""
    : raw.coverUrl ||
      raw.CoverUrl ||
      raw.avatarUrl ||
      raw.AvatarUrl ||
      "";
  const hasContentKey =
    Object.prototype.hasOwnProperty.call(raw, "content") ||
    Object.prototype.hasOwnProperty.call(raw, "Content");
  const content = hasContentKey
    ? raw.content || raw.Content || ""
    : raw.content || raw.Content || raw.summary || raw.Summary || "";
  const category = raw.category || raw.Category || "";
  const time = raw.time || "";
  const author = raw.author || raw.Author || "";
  const status = raw.status || raw.Status || "";
  const thumbs = raw.thumbs || (raw.raw && raw.raw.thumbs) || [];
  const reply = raw.reply || raw.Reply || "";
  const unit = raw.unit || raw.Unit || "";
  const position = raw.position || raw.Position || "";
  const statusTags = Array.isArray(raw.statusTags)
    ? raw.statusTags.filter(Boolean)
    : [];
  const highlight = (raw.highlight || raw.Highlight || "").trim();
  const rating = Math.max(0, Math.min(5, Number(raw.rating) || 0));
  const parts = [status, time, author, category].filter(Boolean);
  return {
    title,
    coverUrl,
    content,
    category,
    time,
    author,
    status,
    reply,
    unit,
    position,
    statusTags,
    highlight,
    rating,
    thumbs: Array.isArray(thumbs) ? thumbs : [],
    thumbsAfter: !!raw.thumbsAfter,
    meta: parts.join(" · "),
    avatarUrl: raw.avatarUrl || raw.AvatarUrl || "",
    raw
  };
}
